<template>
  <QuadroPrincipal :borderTop="borderTop" :titulo="'ICMS'" :classe="classe">
    <RegistrosIcmsInterno
      quadroSecundario
      :id="id"
      :imposto="imposto"
      :edita="edita"
      :seleciona="seleciona"
      :selecionado="selecionado"
      :selecionouIcmsInterno="selecionouIcms"
      :loading="loading"
      :reduzAliquota="reduzAliquota"
      :classe="classe"
    />
  </QuadroPrincipal>
</template>

<script>
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import RegistrosIcmsInterno from "@/components/RegistrosIcmsInterno/RegistrosIcmsInterno.vue";
export default {
  name: "QuadroIcms",

  props: {
    id: String | Number,
    imposto: Object | Array,
    loading: Boolean,
    edita: Function,
    reduzAliquota: String | Number,
    classe: String,
    seleciona: Function,
    selecionado: Object,
    selecionouIcms: Boolean,
    borderTop: Boolean
  },

  components: {
    QuadroPrincipal,
    RegistrosIcmsInterno
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped></style>
